<!--
    描述：用户组
    日期：2021/04/27
    作者：zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>项目组列表</b></span>
                </div>
            </div>

            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content" ref="content">
                        <el-table :data="treeObj.data"
                                  row-key="id"
                                  v-loading="treeObj.loading"
                                  ref="tree"
                                  default-expand-all
                                  :height="treeObj.tableH"
                                  border
                                  highlight-current-row
                                  @row-click="rowClick"
                                  :tree-props="{children: 'children'}">
                            <el-table-column prop="sname"
                                             label="用户组名称"
                                             header-align="center"
                                             show-overflow-tooltip
                                             min-width="130"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { getAllGroups } from 'api/system/sysGroup.js'
export default {
    name : '',
    components: {

    },
    data() {
        return {
            treeObj: {
                loading: false,
                tableH: 200,
                data: []
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.treeObj.tableH = this.$refs.content.offsetHeight
            }, 100)
        })
    },
    computed: {
        ...mapState('app', { clientSize: state => state.clientSize }),
    },
    watch: {
        clientSize(val) {
            this.treeObj.tableH = this.$refs.content.offsetHeight
        }
    },
    created() {
        this.getGroup()
    },
    methods: {
        //获取组信息
        getGroup(){
            let that = this
            let param = {}
            getAllGroups(param).then(res=>{
                if(res.operationCode == 1) {
                    that.treeObj.data = that.$utils.toArrayTree(res.data)
                }
            })
        },
        //行点击
        rowClick(obj) {
            this.$emit('row-click', obj)
        },
    }
}
</script>
<style lang="less">

</style>